/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { employee_selfservice_PersonalDataChanges } from './employee_selfservice_PersonalDataChanges';
export type employee_selfservice_SubmitPersonalDataRequest = {
    /**
     * Changes holds the section's new values (see PersonalDataChanges).
     */
    changes: employee_selfservice_PersonalDataChanges;
    /**
     * Section is the part of the personal data the request changes.
     */
    section: employee_selfservice_SubmitPersonalDataRequest.section;
};
export namespace employee_selfservice_SubmitPersonalDataRequest {
    /**
     * Section is the part of the personal data the request changes.
     */
    export enum section {
        ADDRESS = 'address',
        PHONE = 'phone',
        EMERGENCY_CONTACTS = 'emergency_contacts',
    }
}

